import React, { Component } from 'react';

import Tab from "../../../components/admin/etc/tab";

import Journal from "../../../components/admin/analysis/journal";
import Resource from "../../../components/admin/analysis/resource";
import Scholar from "../../../components/admin/analysis/scholar";
import MailHistory from "../../../components/admin/analysis/mailHistory";
import MailReject from "../../../components/admin/analysis/mailReject";
import { getParams, pushUrl } from '../../../utils/functions'

const vObj = {
  'journal' : <Journal />,
  'resource' : <Resource />,
  'scholar' : <Scholar />,
  'mailHistory' : <MailHistory />,
  'mailReject'  : <MailReject />
}

const arr = {
  'journal' : "저널",
  'resource' : "연구물",
  'scholar' : "연구자",
  'mailHistory' : "메일발송이력",
  'mailReject' : "수신거부자"
};

class Analysis extends Component {
  constructor(props) {
    super(props);

    const activeTabID = getParams('tab_id') ? getParams('tab_id') : 'journal';

    this.state = {
      activeTab: activeTabID === null ? 'journal' : activeTabID
    };
  }

  updateValue = (id) => {
    this.setState({
      activeTab: id
    });

    pushUrl('탭', 'admin.php?page=researchmind-analysis&tab_id='+id, null);
  }

  render() {
    const { updateValue } = this;

    return (
        <>
          <div className="container-fluid mt-3 detail-wrap">
            <div className="row">
              <div className="col pl-0 detail scholar-detail">
                <div className="detail-tabs">
                  <Tab
                      tabList={arr}
                      changeTab={updateValue}
                      activeID={this.state.activeTab}
                  />
                </div>
                <div className="detail-content">
                  {
                    vObj[this.state.activeTab]
                  }
                </div>
              </div>
            </div>
          </div>
        </>
    )
  }
}

export default Analysis